module.exports = __webpack_public_path__ + "static/img/center_d.1c98ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/center_d.png
// module id = 3eWm
// module chunks = 0